<template>
  <el-dialog title="支付订单详情" :visible.sync="dialogVisible" width="950px" :before-close="handleClose"  :close-on-click-modal="false">
    <div>
      <div slot="header" class="clearfix">
        <span>支付信息</span>
      </div>
      <el-form label-width="130px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="合同编号：">
              {{detailData.contractNo}}
            </el-form-item>
            <el-form-item label="付款会员名：">
              {{detailData.payerSysAccountName}}
            </el-form-item>
            <el-form-item label="合同金额(元)：">
              {{$apecUtils.toFinancialNum(detailData.contractAmount, 2, '')}}
            </el-form-item>
            <el-form-item label="交易备注信息：">
              {{detailData.memo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同日期：">
              {{detailData.contractDate}}
            </el-form-item>
            <el-form-item label="收款会员名：">
              {{detailData.receiverSysAccountName}}
            </el-form-item>
             <el-form-item label="退款金额(元)：">
              {{detailData.refundAmount}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="m-t-10">
      <div slot="header" class="clearfix">
        <span>支付结果</span>
      </div>
      <el-form label-width="130px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="支付状态：">
              {{detailData.status | keyFilter("myAccount", "paymentStatus")}}
            </el-form-item>
            <el-form-item label="银行流水号：">
              {{detailData.txTradeNo}}
            </el-form-item>
            <el-form-item label="状态描述：">
              {{detailData.txMsg}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行名称：">
              {{detailData.payerBankName}}
            </el-form-item>
            <el-form-item label="支付时间：">
              {{detailData.payDate}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="text-c m-t-20">
      <el-button size="small" @click="handleClose">返 回</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'paymentDetail',
  props: {
    detailData: {
      type: Object
    }
  },
  components: {
  },

  data () {
    return {
      detail: '',
      dialogData: {},
      dialogVisible: true
    }
  },
  created () {
  },
  methods: {
    handleClose () {
      this.$emit('done')
    }
  },
}
</script>

<style lang="scss" scoped>
.gobal-form{
  .el-input, .el-input__inner{
    width:217px !important;
  }
  div.input-val{
    display:inline-block;
    width:217px;
  }
}
</style>
